export const mapEmpresaParaMyEmp = (empresa: any) => {
  const pbiRelatorioAtivo = empresa.arquiteturasPbi?.find(
    (a: any) => a.chave === empresa.arquiteturaPbiAtiva
  )?.pbiRelatorio;
  return {
    ...empresa,
    pbiRelatorio: pbiRelatorioAtivo,
    lojas: (empresa.lojas || []).map((loja: any) => ({
      ...loja,
      pbiRelatorio: loja.arquiteturasPbi?.find(
        (a: any) => a.chave === loja.arquiteturaPbiAtiva
      )?.pbiRelatorio
    }))
  };
};
